module.exports = __webpack_public_path__ + "static/media/earning.b83f574b.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/constants/video-captions/earning.vtt
// module id = 2179
// module chunks = 0